import { useEffect } from "react";
import { applyUserSettingsToDocument, readStoredSettings } from "@/lib/userSettings";

export default function useUserPreferences() {
  useEffect(() => {
    const syncSettings = () => {
      applyUserSettingsToDocument(readStoredSettings());
    };

    syncSettings();
    window.addEventListener("storage", syncSettings);

    return () => {
      window.removeEventListener("storage", syncSettings);
    };
  }, []);
}
